function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { history } from 'prosemirror-history';
import { Plugin } from 'prosemirror-state';
import { dropCursor } from 'prosemirror-dropcursor';
import { gapCursor } from 'prosemirror-gapcursor';
import { menuBar } from 'prosemirror-menu';
import Placeholder from './Placeholder';
export { EditorState, Selection } from 'prosemirror-state';
export { EditorView } from 'prosemirror-view';
import { listInputRules, linksInputRules, blocksInputRule, baseKeyMaps, textFormattingInputRules } from './rules';
import { buildArticleEditorMenu } from './menu/article';
import { buildMessageEditorMenu } from './menu/message';
export { MessageMarkdownTransformer } from './schema/markdown/messageParser';
export { ArticleMarkdownTransformer } from './schema/markdown/articleParser';
export { ArticleMarkdownSerializer } from './schema/markdown/articleSerializer';
export { MessageMarkdownSerializer } from './schema/markdown/messageSerializer';
export { fullSchema } from './schema/article';
export { messageSchema } from './schema/message';
export function solevatoArticleWriterSetup(props) {
  var plugins = [history(), baseKeyMaps(props.schema), blocksInputRule(props.schema), textFormattingInputRules(props.schema), linksInputRules(props.schema), listInputRules(props.schema), dropCursor(), gapCursor(), Placeholder(props.placeholder), menuBar({
    floating: true,
    content: buildArticleEditorMenu(props.schema, props.onImageUpload).fullMenu
  }), new Plugin({
    props: {
      attributes: {
        class: 'ProseMirror-solevato-style'
      }
    }
  })].concat(_toConsumableArray(props.plugins || []));
  return plugins;
}
export function solevatoMessageWriterSetup(props) {
  var plugins = [].concat(_toConsumableArray(props.plugins || []), [history(), baseKeyMaps(props.schema), blocksInputRule(props.schema), textFormattingInputRules(props.schema), linksInputRules(props.schema), listInputRules(props.schema), dropCursor(), gapCursor(), Placeholder(props.placeholder), menuBar({
    floating: true,
    content: buildMessageEditorMenu(props.schema).fullMenu
  }), new Plugin({
    props: {
      attributes: {
        class: 'ProseMirror-solevato-style'
      }
    }
  })]);
  return plugins;
}